var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("@/assets/pics/no-empty.png")}}),_c('span',[_vm._t("default",function(){return [_vm._v("暂无数据")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }